import { useRouter } from "vue-router";
import client from "../httpClient/client";
import { rollbar } from "../../rollbar";

function getErrorMessage(error: unknown): string {
  if (error && typeof error === "object" && "message" in error) {
    return String((error as { message?: unknown }).message ?? "");
  }
  return "";
}

export async function createBookingInfoToken(payload: Record<string, unknown>) {
  const router = useRouter();
  try {
    const isLocalEnv = process.env.VUE_APP_TARIFF_MANAGER_URL !== undefined;
    const basePath = isLocalEnv ? process.env.VUE_APP_TARIFF_MANAGER_URL : "/";
    return client.postRequest(`${basePath}api/v1/booking_info_tokens`, payload);
  } catch (e: unknown) {
    if (getErrorMessage(e) === "Request failed with status code 404") {
      router.push("/404");
    } else {
      rollbar?.error(e as Error, { context: "createBookingInfoToken" });
    }
  }
}

export async function updateBookingInfoToken(
  tokenId: string,
  payload: Record<string, unknown>,
) {
  const router = useRouter();
  try {
    const isLocalEnv = process.env.VUE_APP_TARIFF_MANAGER_URL !== undefined;
    const basePath = isLocalEnv ? process.env.VUE_APP_TARIFF_MANAGER_URL : "/";
    return client.putRequest(
      `${basePath}api/v1/booking_info_tokens/${tokenId}`,
      payload,
    );
  } catch (e: unknown) {
    if (getErrorMessage(e) === "Request failed with status code 404") {
      router.push("/404");
    } else {
      rollbar?.error(e as Error, { context: "updateBookingInfoToken" });
    }
  }
}
